import { render, staticRenderFns } from "./normal-statistics.vue?vue&type=template&id=7c66bf84"
import script from "./normal-statistics.vue?vue&type=script&lang=js"
export * from "./normal-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports